module.exports = __webpack_public_path__ + "static/media/2000.a58f8a86.jpeg";